import { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import { schemaConditions, schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const OfferRequestConditionsTableDefinitionZod = schemaConditions.merge(
    z.object({
        id: schemaId,
        source: z.literal(LOAN_REQUEST_OFFER_SOURCES.EUROPACE).optional(), // we will not use the source anymore but for backwards compatibility wee need to keep it optional
    }),
);

export type OfferRequestConditionsTableSchema = z.infer<typeof OfferRequestConditionsTableDefinitionZod>;
